module.exports = __webpack_public_path__ + "media/images/bungalow-9134894c5d2b7d6353e29dddb92ad2d4.jpg";